import { render, staticRenderFns } from "./SerpTable.vue?vue&type=template&id=7c1c6ca8&scoped=true"
import script from "./SerpTable.vue?vue&type=script&lang=js"
export * from "./SerpTable.vue?vue&type=script&lang=js"
import style0 from "./SerpTable.vue?vue&type=style&index=0&id=7c1c6ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c6ca8",
  null
  
)

export default component.exports